import React, { useEffect, useState } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from 'classnames';
import MasterUpdateRequestsApproval from "../MasterUpdateRequestsApproval";
import MasterUpdateRequestsDetail from "./MasterUpdateRequestsDetail";

const SupplierListing = () => {
    const detail = JSON.parse(localStorage.getItem("userDetail"));
    const [activeTab, setActiveTab] = useState("1");
    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };
    const [masterUpdateDetail, setMasterUpdateDetail] = useState(null);
    


    return (
        <div className="hl-vendor-need-approval-wrap hl-vl-common-wrap mt-3">
            <div className="hl-approval-tabs">
                <Nav tabs className="subtabs mt-0 p-relative">
                    <NavItem>
                        <NavLink
                            id={`dashboard_Masters_Pending_Approval`}
                            className={classnames({ active: activeTab === '1' })}
                            onClick={() => { toggle('1'); }}
                        >
                            Master Update Requests Detail
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            id={`dashboard_Masters_Awaiting_Approval`}
                            className={classnames({ active: activeTab === '2' })}
                            onClick={() => { toggle('2'); }}
                        >
                            Master Update Requests Approval
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                        <MasterUpdateRequestsDetail />
                    </TabPane>
                    <TabPane tabId="2">
                        <MasterUpdateRequestsApproval />
                    </TabPane>
                </TabContent>
            </div>
        </div>
    );
};

export default SupplierListing;
